import homeDashboardConfig from '../mocks/home-dashboard.json'

const normalizePhone = (value = '') => String(value).replace(/\D/g, '')

export const getHomeDashboardConfig = () => homeDashboardConfig

export const getHomeBillingPlans = () => {
	const plans = Array.isArray(homeDashboardConfig?.billingPlans) ? homeDashboardConfig.billingPlans : []

	return [...plans].sort((first, second) => Number(first?.rank || 0) - Number(second?.rank || 0))
}

export const getHomeSubscription = () => homeDashboardConfig?.subscription || {}

export const getVisibleBillingPlans = ({ mode = 'subscribe', activePlanSlug: resolvedActivePlanSlug } = {}) => {
	const plans = getHomeBillingPlans()
	const subscription = getHomeSubscription()
	const activePlanSlug = String(resolvedActivePlanSlug || subscription?.activePlanSlug || '').trim().toLowerCase()
	const currentPlan = plans.find((plan) => String(plan?.slug || '').trim().toLowerCase() === activePlanSlug) || null

	if (mode === 'upgrade' && currentPlan) {
		return plans.filter((plan) => Number(plan?.rank || 0) > Number(currentPlan?.rank || 0))
	}

	return plans
}

export const getHomeAccountDecorator = (account) => {
	const decorators = homeDashboardConfig?.accountList?.decorators || []
	const accountId = String(account?.id || '')
	const phone = normalizePhone(account?.phone_number)
	const name = String(account?.name || '').trim().toLowerCase()

	return decorators.find((item) => {
		if (item?.accountId && String(item.accountId) === accountId) {
			return true
		}

		if (item?.phone && normalizePhone(item.phone) === phone) {
			return true
		}

		if (item?.name && String(item.name).trim().toLowerCase() === name) {
			return true
		}

		return false
	}) || null
}

export const resolveHomeValue = ({ liveValue, mockValue, preferMock = false, fallbackValue = 0 }) => {
	if (preferMock && mockValue !== undefined && mockValue !== null) {
		return mockValue
	}

	if (liveValue !== undefined && liveValue !== null) {
		return liveValue
	}

	if (mockValue !== undefined && mockValue !== null) {
		return mockValue
	}

	return fallbackValue
}

export const resolveHomeCollection = ({ liveItems, mockItems, preferMock = false }) => {
	if (preferMock && Array.isArray(mockItems)) {
		return mockItems
	}

	if (Array.isArray(liveItems) && liveItems.length) {
		return liveItems
	}

	return Array.isArray(mockItems) ? mockItems : []
}